// Referenz-Detailkopf: Die IBA-Wortmarke bleibt beim Scrollen mit festem Abstand
// über der Viewport-Unterkante „hängen" und wandert dadurch relativ zum Headerbild
// nach unten aus dem Bild hinaus; sie bleibt auf den Bild-Container
// (__imgwrap, overflow:hidden) geclippt und ist so nur über dem Bild sichtbar.
//
// Warum JS statt CSS: position:sticky scheidet aus, weil __imgwrap zum Clippen
// overflow:hidden trägt (bricht sticky). Ein rAF-gedrosselter Scroll-Handler
// setzt daher nur die vertikale Position der Marke (§8: Verhalten in externem JS).
//
// Progressive Enhancement: ohne JS liegt die Marke statisch unten im Bild
// (CSS: bottom). Bei prefers-reduced-motion (§16) kein Parallax -> statisch unten.

// Abstand der Marken-Unterkante zur Viewport-Unterkante (px). Deckungsgleich mit
// dem CSS-Fallback `bottom` in _referenz-detail.scss.
const BOTTOM_GAP = 100;

export function initRefheaderMark() {
  if (typeof window === "undefined") {
    return;
  }
  const marks = document.querySelectorAll(".referenz-header__mark");
  if (!marks.length) {
    return;
  }
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return; // statisch unten (CSS bottom)
  }

  const items = [...marks]
    .map((mark) => ({ mark, wrap: mark.closest(".referenz-header__imgwrap") }))
    .filter((it) => it.wrap);
  if (!items.length) {
    return;
  }

  let ticking = false;
  const update = () => {
    ticking = false;
    const vh = window.innerHeight;
    for (const { mark, wrap } of items) {
      const h = mark.offsetHeight;
      if (!h) {
        continue; // Höhe noch nicht bekannt (SVG lädt) -> CSS-`bottom` greift; load-Event holt nach
      }
      const wr = wrap.getBoundingClientRect();
      // Marke mit festem Abstand über der Viewport-Unterkante halten (NICHT an der
      // Bildunterkante clampen). Beim Weiterscrollen wandert sie dadurch unten aus
      // dem Bild hinaus; __imgwrap (overflow:hidden) blendet den Teil unter der
      // Bildkante aus -> „läuft darüber hinaus, nur im Bildcontainer sichtbar".
      const top = vh - BOTTOM_GAP - h - wr.top;
      mark.style.top = `${Math.round(top)}px`;
    }
  };
  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  // Erstplatzierung robust machen (kein „Reinspringen" beim ersten Scroll): sobald
  // die Marken-SVG bzw. alle Assets geladen sind, steht die Höhe -> neu ausrichten.
  window.addEventListener("load", onScroll);
  items.forEach(({ mark }) => {
    if (!mark.complete) {
      mark.addEventListener("load", onScroll, { once: true });
    }
  });
  update();
}
